module.exports = __webpack_public_path__ + "img/img1.2d73e08c.jpg";